import type { ConfigType } from '@plone/registry';
// @ts-ignore
import Libras from '@plonegovbr/volto-vlibras/components/Libras';

export default function install(config: ConfigType) {
  config.settings.defaultLanguage = 'pt-br';
  config.settings.supportedLanguages = ['pt-br'];

  // Vlibras
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: Libras,
      props: {},
    },
  ];

  return config;
}
